module.exports = {"330922100":"菜园镇","330922101":"嵊山镇","330922102":"洋山镇","330922200":"五龙乡","330922201":"黄龙乡","330922202":"枸杞乡","330922203":"花鸟乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/330922.json
// module id = 1118
// module chunks = 0